import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-16 pb-24 px-4 md:pt-24 md:pb-32 overflow-hidden bg-cream" data-id="element-72">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="z-10" data-id="element-74">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-75">
            ¿Y si pudieras volver a desayunar tus platos favoritos sin que tus
            rodillas y tu estómago te pasen factura?
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-espresso/80 font-medium" data-id="element-76">
            El método de "Sustitución Ancestral" diseñado para la mujer latina
            en USA de 60+ que quiere recuperar su energía sin renunciar al sabor
            de su tierra.
          </p>
          <Button onClick={scrollToCTA} data-id="element-77">¡SÍ, QUIERO MI RECETARIO AHORA!</Button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-78">
          <div className="absolute inset-0 bg-sage/20 rounded-[3rem] transform rotate-3 scale-105 -z-10" data-id="element-79"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pzTirjjSy6CqPJNU1Gy9rv/Recetario_REjuvenece.png" alt="Recetario Rejuvenece en diferentes dispositivos" className="rounded-[2rem] shadow-warm-lg w-full object-cover" data-id="element-80" />
        </motion.div>
      </div>
    </section>;
}